module.exports = __webpack_public_path__ + "img/cta-bg-003.27278add.jpg";